/**
 * LicenseTerm Component
 */

import './styles.scss';

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

import ConnectedLicenseBuilderContainer, {
  LicenseComponentProps,
} from '../../../../../containers/ConnectedLicenseBuilderComponent';

import Button from '../../../../atoms/buttons/Button';
import { IconInfoFilled } from '../../../../atoms/images/Icon';
import Heading from '../../../../atoms/text/Heading';
import { Span } from '../../../../atoms/text/Label';
import { Tooltip } from '../../../../atoms/text/Tooltip';

type LicenseComponentEdge = GQL.ITermEdge;
type LicenseComponentNode = GQL.ITerm;
type LicenseComponentOwnProps = LicenseComponentProps<LicenseComponentEdge>;

const classes = new BEM('license-builder__step');

class LicenseTerm extends React.Component<LicenseComponentOwnProps, {}> {

  shouldComponentUpdate(nextProps: LicenseComponentOwnProps) {
    return nextProps.selectedParam !== this.props.selectedParam ||
      nextProps.editingUsageIndex !== this.props.editingUsageIndex;
  }

  renderButton({ internal_id, name }: LicenseComponentNode) {
    const id = internal_id! as LicenseTermTypeIdentifier;
    const component: ILicenseComponent = { id, name };
    const selectedParam = this.props.selectedParam as ILicenseComponent | null | undefined;
    const extraClassName = classNames(
      { 'is-active': !!selectedParam && id === selectedParam.id },
    );
    return (
      <Button
        onClick={() => {
          this.props.setParam(component);
        }}
        {...classes('button', '', extraClassName) }
        label={name}
        size="small"
        colorScheme="white"
      />
    );
  }

  render() {
    const {
      editingUsageIndex,
    } = this.props;
    const data = this.props.data.slice().sort((a, b) => {
      return a.node!.display_order! - b.node!.display_order!;
    });
    // tslint:disable-next-line:max-line-length
    const tooltipContent = `
    All licenses purchased on Bopper include archival rights for free
    allowing licensees to use the music on all digital media for archival
    purposes, in perpetuity. Examples of archival uses are unpromoted
    social media posts or Youtube archives, and corporate websites.
    Whenever content is promoted, either by purchasing media or paying
    to drive traffic to a website, it is no longer considered an archival
    use.`;

    return (
      <div {...classes('', 'term') }>
        <Heading is="h4" {...classes('title')}>Campaign Duration:</Heading>
        <Span size="medium" variant="note" {...classes('note')}>
          <Span>
            Archival rights are included.
            <Tooltip content={tooltipContent} placement="bottom" theme="black" interactive>
              <IconInfoFilled className="tooltip" />
            </Tooltip>
          </Span>
          <br />
          <Span>
            Learn more about the differences between
            perpetuity and archival uses&nbsp;
            <Button
              label="here"
              variant="hyperlink"
              wrapperComponent="a"
              hyperLinkProps={{
                href: 'https://www.boppermusic.com/blog/archival-rights-weve-got-you-covered/',
                target: '_blank',
              }}
            />.
          </Span>
        </Span>
        <ul>
          {data.map(({ node }) => (
            <li key={`${editingUsageIndex}-${node!.internal_id!}`}>
              {this.renderButton(node!)}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

const ConnectedLicenseTerm =
  ConnectedLicenseBuilderContainer<LicenseComponentEdge>(LicenseTerm, 'term');

export default ConnectedLicenseTerm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/license-builder/SelectTerm/index.tsx